import React from 'react';

import './singlePrivateHeaderChatBtnsComponent.css';

const SinglePrivateHeaderChatBtnsComponent = ({
  isPrivateChatTabSelected = false,
  isSingleChatTabSelected = true,
  privateTabTxt = '',
  singleTabTxt = '',
  onPrivateChatTabClicked = () => {},
  onSingleChatTabClicked = () => {},
}) => {
  return (
    <div className="et-n-single-private-chat-btns-wrap">
      <div
        className={`et-n-single-private-chat-btn ${
          isSingleChatTabSelected ? 'et-n-single-private-chat-btn-selected' : ''
        }`}
        onClick={onSingleChatTabClicked}>
        {singleTabTxt}
      </div>
      <div
        className={`et-n-single-private-chat-btn ${
          isPrivateChatTabSelected
            ? 'et-n-single-private-chat-btn-selected'
            : ''
        }`}
        onClick={onPrivateChatTabClicked}>
        {privateTabTxt}
      </div>
    </div>
  );
};

export default SinglePrivateHeaderChatBtnsComponent;
